interface Props {
  onClick: () => void;
}

const SvgMinus: React.FC<Props> = ({ onClick }) => {
  return (
    <svg
      onClick={onClick}
      style={{ cursor: "pointer" }}
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.99999 5.20003C1.89398 5.19853 1.78873 5.21812 1.69036 5.25765C1.59198 5.29718 1.50245 5.35587 1.42695 5.4303C1.35146 5.50474 1.29151 5.59344 1.25059 5.69124C1.20967 5.78905 1.1886 5.89401 1.1886 6.00003C1.1886 6.10605 1.20967 6.21101 1.25059 6.30882C1.29151 6.40663 1.35146 6.49532 1.42695 6.56976C1.50245 6.64419 1.59198 6.70288 1.69036 6.74241C1.78873 6.78195 1.89398 6.80153 1.99999 6.80003C6.67119 6.80003 4.82974 6.80003 9.99999 6.80003C10.106 6.80153 10.2113 6.78195 10.3096 6.74241C10.408 6.70288 10.4975 6.64419 10.573 6.56976C10.6485 6.49532 10.7085 6.40663 10.7494 6.30882C10.7903 6.21101 10.8114 6.10605 10.8114 6.00003C10.8114 5.89401 10.7903 5.78905 10.7494 5.69124C10.7085 5.59344 10.6485 5.50474 10.573 5.4303C10.4975 5.35587 10.408 5.29718 10.3096 5.25765C10.2113 5.21812 10.106 5.19853 9.99999 5.20003C4.85474 5.20003 6.65099 5.20003 1.99999 5.20003Z"
        className="fill-primary"
      />
    </svg>
  );
};

export default SvgMinus;
